import { Link } from "react-router-dom";
import { ArrowRight, LifeBuoy, ShieldCheck, Network, Code2 } from "lucide-react";
import SEO from "@/components/SEO";
import { services } from "@/data/services";

const ICONS = { "managed-it-support": LifeBuoy, "cloud-cybersecurity": ShieldCheck, "network-infrastructure": Network, "custom-software": Code2 };

const Services = () => (
  <>
    <SEO title="IT Services for Adelaide SMEs | UMI IT Services" description="Managed IT support, cybersecurity, network infrastructure and custom software for Adelaide small businesses. Explore UMI's services and book a free consultation." />

    <section className="bg-[#F8FAFC] pt-28 pb-16 md:pt-36 md:pb-20">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#17B8A6]">Our services</p>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.1] text-[#0B2545]">
          Everything your business IT needs, <span className="text-[#17B8A6]">under one local roof.</span>
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          From day-to-day helpdesk support to long-term technology planning, UMI covers the full IT lifecycle for Adelaide businesses with 5 to 150 staff. One team, one phone number, zero finger-pointing between vendors.
        </p>
      </div>
    </section>

    <section className="py-16 md:py-24 bg-white">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {services.map((s) => {
          const Icon = ICONS[s.slug];
          return (
            <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`services-page-card-${s.slug}`}
              className="group rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 sm:p-8 hover:border-[#17B8A6] hover:shadow-lg transition-all duration-200 hover:-translate-y-1">
              <div className="w-12 h-12 rounded-xl bg-[#0B2545] flex items-center justify-center">
                <Icon size={22} className="text-[#17B8A6]" aria-hidden="true" />
              </div>
              <h2 className="mt-5 text-xl sm:text-2xl font-semibold tracking-tight text-[#0B2545]">{s.title}</h2>
              <p className="mt-2 text-base text-slate-600 leading-relaxed">{s.subtitle}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0D9488]">
                Explore this service <ArrowRight size={15} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>

    <section className="bg-[#0B2545] py-16 md:py-20">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">Not sure which service you need?</h2>
        <p className="mt-4 text-lg text-slate-300 max-w-2xl mx-auto">That's exactly what the free consultation is for. Tell us what's frustrating you and we'll map it to a practical plan.</p>
        <Link to="/contact" data-testid="services-cta-consultation"
          className="mt-8 inline-flex items-center gap-2 bg-[#17B8A6] hover:bg-[#0D9488] text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200 hover:-translate-y-0.5">
          Book a Free Consultation <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </section>
  </>
);

export default Services;
